import { createSlice, isAnyOf, PayloadAction } from "@reduxjs/toolkit"
import { SpeechResponse } from "./interface"
import { candidateInterviewBot } from "./CandidateInterviewBotAction"

interface InterviewBotState {
  speechResponse: SpeechResponse,
  loading: boolean,
  playing: boolean,
  started: boolean,
  ended: boolean,
  recognizing: boolean,
  animationLoaded: boolean,
}

const initialState = {
  speechResponse: {},
  loading: false,
  playing: false,
  started: false,
  ended: false,
  recognizing: false,
  animationLoaded: false,
} as InterviewBotState

const interviewBotSlicer = createSlice({
  name: 'candidate-interviewBot',
  initialState,
  reducers: {
    setPlaying(state, action: PayloadAction<boolean>) {
      state.playing = action.payload
    },
    setRecognizing(state, action: PayloadAction<boolean>) {
      state.recognizing = action.payload
    },
    setAnimationLoaded(state, action: PayloadAction<boolean>) {
      state.animationLoaded = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(candidateInterviewBot.pending, (state: any) => {
        state.loading = true
      })
      .addCase(candidateInterviewBot.fulfilled, (state: any, { payload }) => {
        state.speechResponse = payload
        state.loading = false
        state.started = true

        // assume that audio will start playing
        state.playing = true

        // set ended
        if (state.speechResponse.ended) {
          state.ended = true
          console.log('ended', state.ended)
        }
      })
  },
})

export const { setPlaying, setRecognizing, setAnimationLoaded } = interviewBotSlicer.actions
export default interviewBotSlicer.reducer